// src/pages/cashier/ContinentalEOD.jsx
import React from 'react';
import EndOfDay from '../EndOfDay';

const ContinentalEOD = () => {
  return <EndOfDay locationKey="continental" />;
};

export default ContinentalEOD;